import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-AI4",
  "use": "icon-AI4-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-AI4\"><defs><style type=\"text/css\"></style></defs><path d=\"M502.9 95.1l279 132.6-270.7 127.7-286.3-128.2 278-132.1m0-26.6L167.6 227.8l343.9 154L838 227.7 502.9 68.5zM89.8 344.1l336 158.1V920l-336-158V344.1m-24-37.8v470.9l384 180.6V487l-384-180.7zM935.3 344.1V762l-336 158V502.2l336-158.1m24-37.8L575.3 487v470.8l384-180.6V306.3z\" p-id=\"4814\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol